import React from "react";
import "../styles/ContactSection.css";

const ContactSection = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="contact-title">
          Vedd saját kezedbe az életed, és építs valódi szabadságot
        </h2>

        <p className="contact-lead">
          Sokan érzik úgy, hogy szeretnének többet kihozni az életükből, mégis
          bizonytalanság, félelem vagy korábbi rossz tapasztalatok tartják őket
          vissza. Ha te is egy olyan életre vágysz, ahol valódi döntési
          szabadságod van, kiszámítható jövőt építesz, és nem mások határozzák
          meg a lehetőségeidet, akkor jó helyen jársz.
          <br />
          <br />
          Ez nem gyors ígéretekről vagy üres motivációs mondatokról szól, hanem
          egy működő, évek óta bizonyított szemléletről és útról, amely segít
          lépésről lépésre felépíteni egy önállóbb, stabilabb életet. A
          jelentkezés mindössze néhány percet vesz igénybe, kötelezettségmentes,
          és lehetőséget ad arra, hogy tisztábban lásd, merre és hogyan érdemes
          továbbindulnod.
        </p>
        <a href="/contact" className="contact-cta-btn">
          Jelentkezem
        </a>
      </div>
    </section>
  );
};

export default ContactSection;
